import { motion } from "framer-motion";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { designAni2 } from "./animation";
import DesignsLists from "./DesignsLists";
import { Journey } from "./Journey";

function DesignsShow() {
  const data = useStaticQuery(graphql`
    query {
      allContentfulNewDesigns {
        nodes {
          id
          title
          thumbImage {
            id
            gatsbyImageData(layout: FULL_WIDTH)
          }
          body {
            body
          }
          palette
          showImages {
            id
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
  `);

  const {
    allContentfulNewDesigns: { nodes },
  } = data;

  return (
    <>
      <motion.div className="designs--show">
        <motion.div className="top--design--section">
          <motion.h1
            variants={designAni2}
            initial="initial"
            animate="animate"
            exit={{
              y: 100,
              opacity: 0,
              transition: { duration: 0.6, delay: 0.3 },
            }}
            transition={{ ease: "easeOut", duration: 0.8 }}
          >
            UI and Web designs
          </motion.h1>
          <motion.p
            variants={designAni2}
            initial="initial"
            animate="animate"
            exit={{
              y: 100,
              opacity: 0,
              transition: { duration: 0.6, delay: 0.2 },
            }}
            transition={{ ease: "easeOut", duration: 0.8, delay: 0.2 }}
          >
            Tap the cards to see more details.
          </motion.p>
        </motion.div>
        <DesignsLists images={nodes} />
        <Journey toNav="designjourney" value="My Design Journey" />
      </motion.div>
    </>
  );
}

export { DesignsShow };
